import { EventEmitter, Injectable } from '@angular/core';
import 'rxjs/add/operator/toPromise';

import { LocalStorageProvider, HTTP_STATUS_CODE } from 'app/shared';
import { User, UserId } from './user.model';
import { UserRepository } from './user.repository';
import { PermissionService } from 'app/security/permission';

@Injectable()
export class UserService {

  public onUserChanged: EventEmitter<void> = new EventEmitter<void>();

  private userPromise: Promise<User> = null;
  private userStorageKey: string = 'userUuid';
  private storage: LocalStorageProvider = new LocalStorageProvider();

  constructor(
    private permissionService: PermissionService,
    private userRepository: UserRepository
  ) { }

  public setUserId(userId: UserId) {
    this.storage.set(this.userStorageKey, userId);

    this.permissionService.permissionChanged();
    this.onUserChanged.emit();
  }

  public clearUser() {
    this.userPromise = null;
    this.storage.remove(this.userStorageKey);

    this.permissionService.permissionChanged();
    this.onUserChanged.emit();
  }

  public getUser(): Promise<User> {
    if (null !== this.userPromise) {
      return this.userPromise;
    }

    const storedUserId: string = this.storage.get(this.userStorageKey);

    if (storedUserId !== null) {
      this.userPromise = this.userRepository
        .get(storedUserId)
        .toPromise();

      return this.userPromise;
    }

    return Promise.resolve(null);
  }

}



// WEBPACK FOOTER //
// /dist/src/app/user/user.service.ts